/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'jquery',
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'underscore'
], function($, View, _) {

	var Label = null;

	/**
	 * Represents a drop down menu that can be added to an app bar
	 */
	Label = View.extend({
		baseClass: 'toolbar',

		/**
		 * Creates a Label item
		 *
		 * @param spec -
		 *            The menu item spec
		 * @param root -
		 *            A reference to the root menu item, where items go if the app bar is collapsed horizontally
		 */
		init: function(spec) {
			_.extend(this, spec);
			this._initLabel();
			Label.inherited('init', this, arguments);
		},

		/**
		 * Draws the Label
		 */
		render: function() {
			this.$el
				.empty()
				.addClass(this.baseClass + 'InactiveItem')
				.attr('id', this.viewId);

			this._updateLabel();

			if (this.style) {
				this.$el.addClass(this.style);
			}
			if (this.isStatusLabel) {
				this.$el.attr('role', 'status');
			}
			if (this.editable) {
				this.$el.attr('tabindex','0').inlineEditor(this.changedAction, {
					style: { width: 'auto' },
					noEmptyText: true
				});
			}
			return this;
		},

		_initLabel: function() {
			//If label is a string, simply render this string statically,
			//otherwise, use _getLabel and _updateLabel to keep the UI and
			//model in synch.
			if($.type(this.label) === 'object') {
				this._getLabel = this.label.get;
				this.label.onChange(this._updateLabel, this);
			}
		},

		_getLabel: function() {
			return this.label;
		},

		_updateLabel: function() {
			this.text(this._getLabel());
		},

		/**
		 * Changes the text of the label
		 */
		text: function(value) {
			this.$el.text(value);
		}

	});

	return Label;
});
